<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-29 14:21:08
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-09-26 16:00:48
-->
<template>
  <div class="content">
    <LandMap
      :landList="landList"
      :trajectoryList="trajectoryList"
      :mapTopInfoOptions="mapTopInfoOptions"
    >
      <template
        v-if="fromType == 'edit'"
        v-slot:addWorkAudit="{ curPolygonVal }"
      >
        <div class="btn-wrap">
          <el-button
            class="add-work-audit"
            type="primary"
            icon="el-icon-plus"
            @click="handleAddWorkAudit(curPolygonVal)"
            >添加作业质量审核记录</el-button
          >
        </div>
      </template>
    </LandMap>
    <!-- 添加作业质量审核记录 -->
    <el-dialog
      class="dialog-bg"
      title="作业质量审核"
      :visible.sync="dialogVisible"
      width="450px"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="审核时间" prop="auditTime">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            v-model="ruleForm.auditTime"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="审核人员" prop="auditUserId">
          <el-select
            v-model="ruleForm.auditUserId"
            placeholder="请选择审核人员"
          >
            <el-option label="大田审核人员" value="1122"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核结果" prop="auditResult">
          <el-select
            v-model="ruleForm.auditResult"
            placeholder="请选择审核结果"
          >
            <el-option label="合格" value="1"></el-option>
            <el-option label="不合格" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="ruleForm.remark"
            placeholder="请输入审核备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="照片" prop="workAuditImg" ref="workAuditImg">
          <el-upload
            :action="'#'"
            accept="image/jpeg,image/gif,image/png"
            list-type="picture-card"
            :multiple="true"
            :limit="10"
            v-model="workAuditImg"
            :file-list="fileWorkAuditImgList"
            :data="{ xtype: 'dv', type: 'image' }"
            :on-preview="handlePreviewImg"
            :on-remove="(file) => handleRemoveImg(file, 'workAuditImg')"
            :on-success="(file) => handleImgSuccess(file, 'workAuditImg')"
            :on-change="(file) => handleImgChange(file, 'workAuditImg')"
            :http-request="handleCustomUpload"
            :on-exceed="handleImgExceed"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="previeImgVisible">
            <img width="100%" :src="previewImgUrl" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveAddWorkAudit('ruleForm')"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { uploadImg } from "@/api/uploadImg";
import LandMap from "@/components/LandMap";
import { mapActions, mapState } from "vuex";
export default {
  name: "OrderLand",
  data() {
    return {
      landList: [], // 所有的地块
      trajectoryList: [], // 所有的轨迹块
      workNum: "",
      workTypeId: "",
      mapTopInfoOptions: {
        data: [
          {
            id: 2,
            name: "待审核",
            colour: "#985523",
          },
          {
            id: 3,
            name: "合格",
            colour: "#52c41a",
          },
          {
            id: 4,
            name: "不合格",
            colour: "#e29e00",
          },
        ],
      },
      dialogVisible: false,
      ruleForm: {
        workTypeLandId: "",
        workTypeId: "",
        auditTime: this.getDateNow(),
        auditUserId: "",
        auditResult: "",
        remark: "",
      },
      rules: {
        auditTime: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        auditUserId: [
          { required: true, message: "请选择审核人员", trigger: "change" },
        ],
        auditResult: [
          { required: true, message: "请选择审核结果", trigger: "change" },
        ],
        remark: [
          { required: true, message: "请输入审核备注", trigger: "blur" },
        ],
        workAuditImg: [
          { required: true, message: "请上传照片", trigger: "change" },
        ],
      },
      pickerOptions: this.setPickerOptions(),
      workAuditImg: [], // 审核照片
      fileWorkAuditImgList: [], // 审核照片
      previewImgUrl: "",
      previeImgVisible: false,
    };
  },
  props: {
    orderId: {
      type: String,
    },
    fromType: {
      type: String,
    },
  },
  components: {
    LandMap,
  },
  computed: {
    ...mapState("map", {
      showTrajectory: (state) => state.showTrajectory,
    }),
  },
  watch: {
    showTrajectory(n) {
      if (n) {
        if (this.orderId && this.showTrajectory) {
          let params = { workTypeId: this.orderId };
          this.getOrderTrajectory(params);
        }
      }
    },
  },
  created() {
    this.getOrderLandList({ workTypeId: this.orderId });
  },
  methods: {
    ...mapActions("map", ["changeShowTrajectory"]),
    /**
     * @descripttion: 设置选择日期不能大于当前
     * @Author: juanjuanhui
     * @Date: 2021-12-14 21:02:01
     */
    setPickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() >= Date.now();
        },
      };
    },
    /**
     * @descripttion: 获取当前日期
     * @Author: juanjuanhui
     * @Date: 2022-01-14 15:12:37
     */
    getDateNow() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth();
      var date = now.getDate();
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      return `${year}-${month}-${date}`;
    },
    /**
     * @descripttion: 获取地块信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:34
     */
    getOrderLandList(params) {
      this.$http.cooperative.getWorkTypeLandList(params).then((res) => {
        this.landList = res.data;
      });
    },
    /**
     * @descripttion: 获取轨迹块
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:39:56
     */
    getOrderTrajectory(params) {
      this.$http.cooperative.getWorkTypeTrajectory(params).then((res) => {
        this.trajectoryList = res.data;
      });
    },
    /**
     * @descripttion: 添加作业质量审核
     * @Author: juanjuanhui
     * @Date: 2022-01-14 15:23:39
     */
    handleAddWorkAudit(curPolygonVal) {
      this.ruleForm.workTypeLandId = curPolygonVal.workLandId;
      this.ruleForm.workTypeId = curPolygonVal.workTypeId;
      this.dialogVisible = true;
    },
    /**
     * @descripttion: 获取提交参数
     * @Author: juanjuanhui
     * @Date: 2021-11-25 11:37:22
     * @param {*}
     */
    getParams() {
      let workAuditFileDtos = [];
      this.workAuditImg.forEach((item) => {
        workAuditFileDtos.push({
          picPath: item.url,
          fileName: item.name,
        });
      });
      let params = {
        ...this.ruleForm,
        workAuditFileDtos,
      };
      return params;
    },
    /**
     * @descripttion: 保存作业质量审核信息
     * @Author: juanjuanhui
     * @Date: 2022-01-14 15:24:30
     * @param {*} formName
     */
    handleSaveAddWorkAudit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.getParams();
          this.$http.village.addWorkAudit(params).then((res) => {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.dialogVisible = false;
            this.$router.go(-1);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * @descripttion: 自定义上传图片
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:22:49
     * @param {*} content
     */
    handleCustomUpload(content) {
      uploadImg(content)
        .then((res) => {
          content.onSuccess(res.data);
        })
        .catch((err) => {
          content.onError(err);
          this.$message.error("服务器异常，请重新上传");
        });
    },
    /**
     * @descripttion: 上传图片成功
     * @Author: juanjuanhui
     * @Date: 2021-11-16 21:05:03
     * @param {*} file
     * @param {*} type
     * @return {*}
     */
    handleImgSuccess(file, type) {
      if (file.status != 111111) {
        this.$message.error(file.message);
        return;
      }
      switch (type) {
        case "workAuditImg":
          this[type].push({
            thumb: file.thumb,
            url: file.url,
          });
          break;
      }
    },
    /**
     * @descripttion: 删除图片
     * @Author: juanjuanhui
     * @Date: 2021-11-16 21:05:13
     * @param {*}
     * @return {*}
     */
    handleRemoveImg(file, type) {
      switch (type) {
        case "workAuditImg":
          this[type] = this[type].filter((item) => {
            return item.url != file.url;
          });
          break;
      }
    },
    /**
     * @descripttion: 图片改变
     * @Author: juanjuanhui
     * @Date: 2021-11-16 21:05:13
     * @param {*}
     * @return {*}
     */
    handleImgChange(file, type) {
      switch (type) {
        case "workAuditImg":
          if (this.workAuditImg.length > 0) {
            let { workAuditImg, ...data } = this.rules;
            this.rules = data;
            this.$refs.ruleForm.clearValidate("workAuditImg");
          } else {
            this.rules.workAuditImg = [
              { required: true, message: "请上传照片", trigger: "change" },
            ];
          }
          break;
      }
    },
    /**
     * @descripttion: 预览图片
     * @Author: juanjuanhui
     * @Date: 2021-07-08 21:55:27
     * @param {Object} file 视频文件信息
     */
    handlePreviewImg(file) {
      this.previewImgUrl = file.response ? file.response.url : file.url;
      this.previeImgVisible = true;
    },
    /**
     * @descripttion: 图片超出限制
     * @Author: juanjuanhui
     * @Date: 2021-12-14 21:14:02
     * @param {*} files
     * @param {*} fileList
     */
    handleImgExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  .add-work-audit {
    width: 100%;
    margin-top: 20px;
  }
}
::v-deep {
  .el-dialog {
    .el-dialog__body {
    }
    .el-dialog__footer {
      padding-top: 0;
      text-align: center;
    }
  }
}
</style>
